// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Q89q","productName":"Table_productName__eSxR0"};